import { appSettings } from '@/shared/consts/appSettings'
import { FeaturesFlagsProvider } from '@rededor/ap-shared-components-frontend'
import { PropsWithChildren } from 'react'

export const FeatureFlagsApCore = ({ children }: PropsWithChildren) => {
  return (
    <FeaturesFlagsProvider
      application={appSettings.applicationName}
      clientId={appSettings.patientArea.clientId}
      baseUrl={appSettings.patientArea.baseUrl}
      featureFlagKey="feature-flag/notificacoes,apcore"
      flagMapping={{
        privacyToolsAtivo: 'valor.privacyToolsAtivo',
        messenger: 'valor.messenger',
        push: 'valor.push',
        capturaEmailAtivo: 'valor.capturaEmailAtivo',
        gerais: 'valor.gerais'
      }}
    >
      {children}
    </FeaturesFlagsProvider>
  )
}
